<template>
  <div class="infromtion" id="infromtion" :style="{height:'100%',width:'100%',backgroundColor:graphImageBackground,}"
       @click="overlick">
    <!-- 不加滚动条模式 -->
    <!-- <div class="myclass" id="div_img">
      <img  :src="codeBase" :style=" {marginLeft: (imageWidth -  Math.min(imageWidth, imWidth* (imageheight < imageWidth ? imageheight / imHeight : imageWidth / imWidth) + (imageWidth - imWidth* (imageheight < imageWidth ? imageheight / imHeight : imageWidth / imWidth)) * 0.7)) / 2+ 'px' ,
      height: ((imHeight, Math.min(imageheight, imHeight * (imageheight < imageWidth ? imageheight / imHeight : imageWidth / imWidth) ))).toString() + 'px',
      width: ((imWidth, Math.min(imageWidth, imWidth* (imageheight < imageWidth ? imageheight / imHeight : imageWidth / imWidth) + Math.max(0, (imageWidth - imWidth* (imageheight < imageWidth ? imageheight / imHeight : imageWidth / imWidth)) * 0.7)))).toString() + 'px',
      marginLeft: (imageWidth1 > imWidth && imageheight1 > imHeight) ? '0px' : Math.max(0, imageWidth1 - imWidth) / 2 + 'px' , }" >
    </div> -->
    <!-- 存在滚动条模式 -->
    <div class="myclass" id="div_img" ref="parent">
      <img :src="codeBase" :style=" {marginLeft: Math.max(0, (imageWidth - Math.max(imWidth, Math.min(imageWidth, imWidth* (imageheight < imageWidth ? imageheight / imHeight : imageWidth / imWidth) + (imageWidth - imWidth* (imageheight < imageWidth ? imageheight / imHeight : imageWidth / imWidth)) * 0.7)))) / 2+ 'px' ,
      height: (Math.max(imHeight, Math.min(imageheight, imHeight * (imageheight < imageWidth ? imageheight / imHeight : imageWidth / imWidth) ))).toString() + 'px',
      width: (Math.max(imWidth, Math.min(imageWidth, imWidth* (imageheight < imageWidth ? imageheight / imHeight : imageWidth / imWidth) + Math.max(0, (imageWidth - imWidth* (imageheight < imageWidth ? imageheight / imHeight : imageWidth / imWidth)) * 0.7)))).toString() + 'px',
      }">
    </div>
    <!--      <img  :src="codeBase" :style="{height:'100%',width:'100%', objectFit:'cover'}" >-->
    <!--      <p  class="equipmentName" :style="{top:equipmentNameTop * Math.max(1,Math.min(imageheight1 / imHeight, imageWidth1 / imWidth)) + 'px',left:(myleft(equipmentsName)) + 'px', height:equipmentNameHight * Math.min(this.imageheight1 / this.imHeight, this.imageWidth1 / this.imWidth) + 'px',width:equipmentNameWidth, fontSize: 24 + 'px'} " > {{this.equipmentsName}}</p>-->
    <!--      <p class="equipmentTime" :style="{top:timeTop * Math.max(1,Math.min(imageheight1 / imHeight, imageWidth1 / imWidth)) + 'px',left:(myleft(equipmentsName)+myLength(equipmentsName)) + 'px',height:timeHight * Math.min(imageheight1 / imHeight, imageWidth1 / imWidth) + 'px',width:timeLength(this.time) + 'px', fontSize:fontSize + 'px'}" >{{this.time}}</p>-->
    <!--      <p class="revInfo" :style="{top:revInfoTop * Math.max(1,Math.min(imageheight1 / imHeight, imageWidth1 / imWidth)) + 'px',left:(myleft(equipmentsName)+myLength(equipmentsName)) + 'px',height:revInfoHight * Math.min(imageheight1 / imHeight, imageWidth1 / imWidth) + 'px',width:timeLength(this.time) + 'px', fontSize:fontSize + 'px'}" >revName</p>-->
    <div class="info">
      <table>
        <tr>
          <td>{{ equipmentsName }}</td>
          <td colspan="2" :style="{fontSize:fontSize + 'px', textAlign: 'right'}">{{ timeComputed }}</td>
        </tr>
        <tr v-for="(revInfo, index) in revInfoList" :key="revInfo.revName">
          <td></td>
          <td :style="{fontSize:fontSize + 'px', textAlign: 'right'}">{{ revInfo.revName }}:</td>
          <td :style="{fontSize:fontSize + 'px', textAlign: 'right'}">{{ revInfo.revValue }}</td>
        </tr>
      </table>
    </div>


    <!-- <p class="equipmentTime" :style="{top:timeTop * Math.min(imageheight / imHeight, imageWidth / imWidth) + 'px',left:timeLeft,height:timeHight * Math.min(imageheight / imHeight, imageWidth / imWidth) + 'px',width:timeWidth * Math.ceil(20 * Math.min(this.imageheight / this.imHeight, this.imageWidth / this.imWidth)) + 'px', fontSize:Math.ceil(20 * Math.min(this.imageheight / this.imHeight, this.imageWidth / this.imWidth)) + 'px'}" >{{this.time}}</p>
    <p class="revInfo" :style="{top:revInfoTop * Math.min(imageheight / imHeight, imageWidth / imWidth) + 'px',left:revInfoLeft,height:revInfoHight * Math.min(imageheight / imHeight, imageWidth / imWidth) + 'px',width:revInfoWidth * Math.ceil(20 * Math.min(this.imageheight / this.imHeight, this.imageWidth / this.imWidth)) + 'px', fontSize:Math.ceil(20 * Math.min(this.imageheight / this.imHeight, this.imageWidth / this.imWidth)) + 'px'}" >{{  this.revInfo.revName+' '}}{{ this.revInfo.revValue}}</p> -->
    <!-- <div id="gmt"></div> -->
    <!-- 不加滚动条模式 -->
    <!-- <div class="myclass" id="div_info"
    :style="{marginLeft: (imageWidth1 > imWidth && imageheight1 > imHeight) ? (imageWidth - Math.min(imageWidth, imWidth* (imageheight < imageWidth ? imageheight / imHeight : imageWidth / imWidth) + Math.max(0, (imageWidth - imWidth* (imageheight < imageWidth ? imageheight / imHeight : imageWidth / imWidth)) * 0.7))) / 2 + 'px' : Math.max(0, imageWidth1 - imWidth) / 2 + 'px', }">
      <div
        v-for="(item,i) in listBoxes"
        v-show="item.height > 0"
        :id="'id_box' + i"
        :key="'id_box' + i"
        :class="'point_box point_box' + i"
        :style="{
        width: Math.floor(parseInt(item.width, 10) / imWidth * (Math.min(imageWidth, imWidth* (imageheight < imageWidth ? imageheight / imHeight : imageWidth / imWidth) + Math.max(0, (imageWidth - imWidth* (imageheight < imageWidth ? imageheight / imHeight : imageWidth / imWidth)) * 0.7)))) + 'px',
        height: Math.max(0, Math.floor(parseInt(item.height, 10) / imHeight * (Math.min(imageheight, imHeight * (imageheight < imageWidth ? imageheight / imHeight : imageWidth / imWidth))) - 3)) + 'px',
        top: Math.floor(parseInt(item.yPos, 10) / imHeight * (Math.min(imageheight, imHeight * (imageheight < imageWidth ? imageheight / imHeight : imageWidth / imWidth)))) + 'px',
        left: Math.floor(parseInt(item.xPos, 10) / imWidth * (Math.min(imageWidth, imWidth * (imageheight < imageWidth ? imageheight / imHeight : imageWidth / imWidth) + Math.max(0, (imageWidth - imWidth* (imageheight < imageWidth ? imageheight / imHeight : imageWidth / imWidth)) * 0.7)))) + 'px' ,
        backgroundColor: graphImageBackground,
        }">

        <li
          v-for="(val,j) in item.points"
          :key="j"
          :class="'alarmStatus_' + val.status"
          :title="val.pointId"
        >
          <span
            :style="'width:'+(calMaxWidth(Math.floor(parseInt(item.width,10)/imWidth * imageWidth), item.points, j) ).toString()+'px; ' +
             'display:-moz-inline-box; ' +
             'display:inline-block;' +
             'overflow: hidden; ' +
             'vertical-align: top;' +
              'font-size:'+ 7 * Math.min(imageheight / imHeight, imageWidth / imWidth) + 'px'"
          >{{val.pointId}}</span>

          <span :style="'margin-left: 6px;' +
          'font-size:'+ 7 * Math.min(imageheight / imHeight, imageWidth / imWidth) + 'px' "
          >{{val.value}}</span>
        </li>
      </div>c
    </div> -->
    <!-- 加滚动模式 -->
    <div class="myclass" id="div_info"
         :style="{marginLeft: Math.max(0, (imageWidth - Math.max(imWidth, Math.min(imageWidth, imWidth* (imageheight < imageWidth ? imageheight / imHeight : imageWidth / imWidth) + (imageWidth - imWidth* (imageheight < imageWidth ? imageheight / imHeight : imageWidth / imWidth)) * 0.7)))) / 2+ 'px' ,
      }">
      <div
        v-for="(item,i) in listBoxes"
        v-show="item.height > 0 && item.width > 0 && item.points.length>0 "
        :id="'id_box' + i"
        :key="'id_box' + i"
        :class="'point_box point_box' + i"
        :style="{
        width: Math.floor(parseInt(item.width, 10) / imWidth * (Math.max(imWidth, Math.min(imageWidth, imWidth* (imageheight < imageWidth ? imageheight / imHeight : imageWidth / imWidth) + Math.max(0, (imageWidth - imWidth* (imageheight < imageWidth ? imageheight / imHeight : imageWidth / imWidth)) * 0.7))))) + 'px',
        height: Math.max(0, Math.floor(parseInt(item.height, 10) / imHeight * (Math.max(imHeight, Math.min(imageheight, imHeight * (imageheight < imageWidth ? imageheight / imHeight : imageWidth / imWidth) ))) - 3)) + 'px',
        top: Math.floor(parseInt(item.yPos, 10) / imHeight * (Math.max(imHeight, Math.min(imageheight, imHeight * (imageheight < imageWidth ? imageheight / imHeight : imageWidth / imWidth) )))) + 'px',
        left: Math.floor(parseInt(item.xPos, 10) / imWidth * (Math.max(imWidth, Math.min(imageWidth, imWidth* (imageheight < imageWidth ? imageheight / imHeight : imageWidth / imWidth) + Math.max(0, (imageWidth - imWidth* (imageheight < imageWidth ? imageheight / imHeight : imageWidth / imWidth)) * 0.7))))) + 'px' ,
        backgroundColor: graphImageBackground
        }">

        <li
          v-for="(val,j) in item.points"
          :key="j"
          :class="'alarmStatus_' + getstatus(val.status)"
          :title="val.pointId"
          @contextmenu.prevent="handleClick(val.pointId, $event)"
        >
          <span
            :style="'width:'+(calMaxWidth(Math.floor(parseInt(item.width,10)/imWidth * imageWidth), val.pointId, i) ).toString()+'px; ' +
             'display:-moz-inline-box; ' +
             'display:inline-block;' +
             'overflow: hidden; ' +
             'vertical-align: top;' +
              'font-size:' + fontSize + 'px'"
          >{{ val.pointId }}</span>

          <span :style="'margin-left: 6px;' +
          'font-size:'+ fontSize + 'px' "
          >{{ getValue(val.value) }}</span>
        </li>

      </div>
    </div>
    <div class="routeMenu" id="routeMenu" ref="box" v-show="showMenu"
         :style="{top: y + 'px', left: x + 'px', zIndex: 4}">
      <div class="sele">
        <i v-if="!boxFlag" class="el-icon-caret-left"></i>
        {{ translateText('textMap.','切换')}}
        <i v-if="boxFlag" class="el-icon-caret-right"></i>
      </div>
      <ul class="menu">
        <li
          v-for="(val, item) in menuList"
          :key="item"
          @click="handleSelect(val.path)">
          <img :src="val.src">
          {{ val.name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import menu from "../../Page/menu";
import keepAliveMixin from "../../mixins/keepAliveMixin";
import {timestampToTimeFormat} from "./TimeFormat";

var elementResizeDetectorMaker = require("element-resize-detector");
export default {
  name: "UnitOverviewGrap",
  mixins: [keepAliveMixin],
  props: ['nowtimeStatic', 'getScrollValue'],
  data() {
    return {
      imgUrl_UnitMap: require("../../assets/unitmap.png"),
      imgUrl_Alarm_Q: require("../../assets/Alarm_Q.png"),
      imgUrl_Trend_A: require("../../assets/Trend_A.png"),
      imgUrl_Pump_P: require("../../assets/Pump_P.png"),
      imgUrl_Other_P: require("../../assets/Other_P.png"),
      imgUrl_RotorFault_D: require("../../assets/RotorFault_D.png"),
      imgUrl_Cepstrum_G: require("../../assets/Cepstrum_G.png"),
      imgUrl_Single_Multi: require("../../assets/Single_Multi.png"),
      imgUrl_Other_Parameters: require("../../assets/Other_Parameters.png"),
      imgUrl_Xuan_Map: require("../../assets/Xuan_Map.png"),
      imgUrl_XuanVib: require("../../assets/XuanVib.png"),
      imgUrl_XuanHisCompare: require("../../assets/Xuan_HisCompare.png"),
      imgUrl_XuanZhouG: require("../../assets/Xuan_ZhouG.png"),
      imgUrl_XuanZhouW: require("../../assets/Xuan_ZhouW.png"),
      imgUrl_XuanStartStop: require("../../assets/Xuan_StartStop.png"),
      imgUrl_Xuan_ZongH: require("../../assets/Xuan_ZongH.png"),
      imgUrl_Xuan_RunS: require("../../assets/Xuan_RunS.png"),
      imgUrl_AllS: require("../../assets/Xuan_AllS.png"),
      imgUrl_TwoS: require("../../assets/Xuan_TwoS.png"),
      imgUrl_ThreeS: require("../../assets/Xuan_ThreeS.png"),
      imgUrl_DPH: require("../../assets/Xuan_DPH.png"),
      imgUrl_WangFM: require("../../assets/WangFM.png"),
      imgUrl_Wang_HBai: require("../../assets/Wang_HBai.png"),
      imgUrl_Wang_HGuiJi: require("../../assets/WangHGuiJi.png"),
      imgUrl_Wang_SG: require("../../assets/WangSG.png"),
      imgUrl_Wang_YJ: require("../../assets/Wang_YJ.png"),
      imgUrl_Wang_DCS: require("../../assets/Wang_DCS.png"),
      num: 0,
      marginleft: this.$store.state.marginleftvalue,
      interval2: null,
      fontSize: 12,
      oldHeight: '',
      oldWidth: '',
      imWidth: 0,
      imHeight: 0,
      nowwin: 1,
      equipmentNameHight: '',
      equipmentNameWidth: '',
      equipmentNameTop: '',
      equipmentNameleft: '',
      namefontsize: '9px',
      timeHight: '',
      timeWidth: '',
      timeTop: '',
      timeLeft: '',
      timefontize: '9px',
      revInfoHight: '',
      revInfoWidth: '',
      revInfoTop: '',
      revInfoLeft: '',
      revfontsize: '9px',

      imageheight: '',
      imageWidth: '',
      imageheight1: '',
      imageWidth1: '',
      equipmentsName: '',
      time: '',
      revInfo: {
        revName: '',
        revValue: '',
      },
      revInfoList: [],
      ifnowdata: true,
      nowstatus: -1,  ///为了配合keepAliveMixi中的nowstatus，与ifnowdata保持一致
      codeBase: '',
      graphDataTime: '',
      myinterval: null,
      show: false,
      mapheight: '100%',
      graphheight: '0%',
      showOpPage: true,
      graphImageBackground: '',
      listBoxes: [],
      listSpan: {},
      tmpnum: 0,
      apiflag: true,
      showMenu: false,
      x: 0,
      y: 0,
      pointId: '',
      boxFlag: false
      // nnnn: 0
    }
  },
  computed: {

    timeComputed() {
      return this.time;
    },
    getequName() {
      return this.$store.state.equName;
    },
    equid() {
      return this.$store.state.equid;
    },
    newstate() {
      return this.$store.state.newstate
    },
    windowScreenWidth() {
      return window.screen.width
    },
    //每个插件的菜单不同，需要判断显示
    menuList() {
      if (this.$route.path.indexOf('RotatingMachineryGraph') != -1) {
        return [
          {
            name: this.translateText("textMap.",'旋转报警查询'),
            src: this.imgUrl_Alarm_Q,
            path: '/RotatingMachineryGraph/AlarmQueryGraph2'
          },
          {
            name: this.translateText("textMap.",'温度分布场'),
            src: this.imgUrl_Xuan_RunS,
            path: '/RotatingMachineryGraph/TemperatureiDstributionField'
          },
          {
            name: this.translateText("textMap.",'振动监测'),
            src: this.imgUrl_XuanVib,
            path: '/RotatingMachineryGraph/RotatingVibrationMonitor'
          },
          {
            name: this.translateText("textMap.",'振动历史比较'),
            src: this.imgUrl_XuanHisCompare,
            path: '/RotatingMachineryGraph/VibrationHistoricalComparison'
          },
          {
            name: this.translateText("textMap.",'单多值棒图'),
            src: this.imgUrl_Single_Multi,
            path: '/RotatingMachineryGraph/SingleMultiBarValueChart'
          },
          {
            name: this.translateText("textMap.",'轴心轨迹'),
            src: this.imgUrl_XuanZhouG,
            path: '/RotatingMachineryGraph/OrbitOfShaftCenter1'
          },
          {
            name: this.translateText("textMap.",'轴心位置'),
            src: this.imgUrl_XuanZhouW,
            path: '/RotatingMachineryGraph/AxisPosition'
          },
          {
            name: this.translateText("textMap.",'启停车图形'),
            src: this.imgUrl_XuanStartStop,
            path: '/RotatingMachineryGraph/StartStopGraph'
          },
          {
            name: this.translateText("textMap.",'综合分析'),
            src: this.imgUrl_Xuan_ZongH,
            path: '/RotatingMachineryGraph/RotatingComprehensiveAnalysis'
          },
          {
            name: this.translateText("textMap.",'运行状态图'),
            src: this.imgUrl_Xuan_RunS,
            path: '/RotatingMachineryGraph/RotatingRunStatusGraph'
          },
          {
            name: this.translateText("textMap.",'其它参数趋势图'),
            src: this.imgUrl_XuanZhouW,
            path: '/RotatingMachineryGraph/OtherParametersTrendGraph2'
          },
          {
            name: this.translateText("textMap.",'全频谱图'),
            src: this.imgUrl_AllS,
            path: '/RotatingMachineryGraph/WholeSpectrumGraph'
          },
          {
            name: this.translateText("textMap.",'参数比较查询'),
            src: this.imgUrl_DPH,
            path: '/RotatingMachineryGraph/ParameterComparisonQuery'
          },
        ]
      } else if (this.$route.path.indexOf('gasTurbineGraph/GasOverviewGrap') != -1) {
        return [
          {
            name: '燃气轮机报警查询',
            src: this.imgUrl_Alarm_Q,
            path: '/gasTurbineGraph/AlarmQueryGraph2'
          },
          {
            name: '温度分布场',
            src: this.imgUrl_AllS,
            path: '/gasTurbineGraph/TemperatureiDstributionField1'
          },
          {
            name: '振动监测',
            src: this.imgUrl_XuanVib,
            path: '/gasTurbineGraph/GasVibrationMonitor'
          },
          {
            name: '振动历史比较',
            src: this.imgUrl_XuanHisCompare,
            path: '/gasTurbineGraph/VibrationHistoricalComparison'
          },
          {
            name: '单多值棒图',
            src: this.imgUrl_Single_Multi,
            path: '/gasTurbineGraph/GasSingleMultaBarGraph'
          },
          {
            name: '轴心轨迹',
            src: this.imgUrl_XuanZhouG,
            path: '/gasTurbineGraph/OrbitOfShaftCenter1'
          },
          {
            name: '轴心位置',
            src: this.imgUrl_XuanZhouW,
            path: '/gasTurbineGraph/AxisPosition'
          },
          {
            name: '启停车图形',
            src: this.imgUrl_XuanStartStop,
            path: '/gasTurbineGraph/StartStopGraph'
          },
          {
            name: '综合分析',
            src: this.imgUrl_Xuan_ZongH,
            path: '/gasTurbineGraph/RotatingComprehensiveAnalysis'
          },
          {
            name: '运行状态图',
            src: this.imgUrl_Xuan_RunS,
            path: '/gasTurbineGraph/RotatingRunStatusGraph'
          },
          {
            name: '其它参数趋势图',
            src: this.imgUrl_Other_Parameters,
            path: '/gasTurbineGraph/OtherParametersTrendGraph2'
          },
          {
            name: '全频谱图',
            src: this.imgUrl_AllS,
            path: '/gasTurbineGraph/WholeSpectrumGraph'
          },
          {
            name: '参数比较查询',
            src: this.imgUrl_DPH,
            path: '/gasTurbineGraph/ParameterComparisonQuery'
          },
        ]
      } else if (this.$route.path.indexOf('ReciprocatMachineryGraph/OverviewGraph1') != -1) {
        return [
          {
            name: this.translateText("textMap.",'往复报警查询'),
            src: this.imgUrl_Alarm_Q,
            path: '/ReciprocatMachineryGraph/ReciprocatAlarmQuery'
          },
          {
            name: this.translateText("textMap.",'运行状态图'),
            src: this.imgUrl_Xuan_RunS,
            path: '/ReciprocatMachineryGraph/RunStatusGraph1'
          },
          {
            name: this.translateText("textMap.",'历史比较图'),
            src: this.imgUrl_XuanHisCompare,
            path: '/ReciprocatMachineryGraph/HistoricalComparisonGraph1'
          },
          {
            name: this.translateText("textMap.",'单值棒图'),
            src: this.imgUrl_Single_Multi,
            path: '/ReciprocatMachineryGraph/SingleValueStickGraph1'
          },
          {
            name: this.translateText("textMap.",'活塞杆沉降/偏摆监测'),
            src: this.imgUrl_Wang_HBai,
            path: '/ReciprocatMachineryGraph/PistonRodSettlement'
          },
          {
            name: this.translateText("textMap.",'振动监测'),
            src: this.imgUrl_XuanVib,
            path: '/ReciprocatMachineryGraph/ReciprocatVibrationMonitor'
          },
          {
            name: this.translateText("textMap.",'多参数分析'),
            src: this.imgUrl_Wang_DCS,
            path: '/ReciprocatMachineryGraph/MultiparameterAnalysis1'
          },
          {
            name: this.translateText("textMap.",'综合监测'),
            src: this.imgUrl_Xuan_ZongH,
            path: '/ReciprocatMachineryGraph/ReciprocatComprehensiveAnalysis'
          },
          {
            name: this.translateText("textMap.",'其它参数趋势图'),
            src: this.imgUrl_Other_Parameters,
            path: '/ReciprocatMachineryGraph/OtherParametersTrend1'
          },
          {
            name: this.translateText("textMap.",'示功图'),
            src: this.imgUrl_Wang_SG,
            path: '/ReciprocatMachineryGraph/IndicatorGraph1'
          }
        ]
      } else if (this.$route.path == '/UnitOverviewMap') {
        return [
          {
            name: this.translateText("textMap.",'报警查询'),
            src: this.imgUrl_Alarm_Q,
            path: '/AlarmQueryGraph'
          },
          {
            name: this.translateText("textMap.",'趋势分析'),
            src: this.imgUrl_Trend_A,
            path: '/TrendAnalysis'
          },
          {
            name: this.translateText("textMap.",'冲击诊断'),
            src: this.imgUrl_Pump_P,
            path: '/PumpImpactDiagnosis'
          },
          {
            name: this.translateText("textMap.",'转子类故障诊断'),
            src: this.imgUrl_RotorFault_D,
            path: '/RotorFaultDiagnosis'
          },
          {
            name: this.translateText("textMap.",'倒谱图'),
            src: this.imgUrl_Cepstrum_G,
            path: '/CepstrumGraph'
          },
          {
            name: this.translateText("textMap.",'单多值棒图'),
            src: this.imgUrl_Single_Multi,
            path: '/SingleMultiBarValueChart'
          },
          {
            name: this.translateText("textMap.",'其它参数趋势图'),
            src: this.imgUrl_Other_Parameters,
            path: 'OtherParametersTrendGraph'
          },
        ]
      } else if (this.$route.path == '/WirelessPumpGraph/WirelessPumpUnitOverviewMap') {
        return [
          {
            name: '机泵报警查询',
            src: this.imgUrl_Alarm_Q,
            path: '/WirelessPumpGraph/WirelessPumpAlarmQueryGraph'
          },
          {
            name: '趋势分析',
            src: this.imgUrl_Trend_A,
            path: '/WirelessPumpGraph/WirelessPumpTrendAnalysis'
          },
          {
            name: '冲击诊断',
            src: this.imgUrl_Pump_P,
            path: '/WirelessPumpGraph/WirelessPumpImpactDiagnosis'
          },
          {
            name: '其它参数趋势图',
            src: this.imgUrl_Other_Parameters,
            path: '/WirelessPumpGraph/WirelessPumpOtherParametersTrendGraph'
          },
          {
            name: '波形频谱对比分析',
            src: this.imgUrl_Other_Parameters,
            path: '/WirelessPumpGraph/WaveformSpectraComparativeAnalysis'
          }
        ]
      } else if (this.$route.path == '/HeatingFurnaceGraph/HeatingFurnaceUnitOverviewMap') {
        return [
          {
            name: '其它参数趋势图',
            src: this.imgUrl_Other_Parameters,
            path: '/HeatingFurnaceGraph/HeatingFurnaceOtherParametersTrendGraph'
          },
        ]
      }
    },
    equipmentDetail(){
      return this.$store.state.equipmentDetail
    }
  },
  // 有滚动条时使用
  // updated() {
  //   if(this.tmpnum <= 2) {
  //     this.$nextTick(()=> {
  //       // console.log('第几次', this.tmpnum);
  //       this.$refs.parent.parentElement.parentElement.scrollLeft = (this.imWidth * 0.2).toString();
  //     })
  //     this.tmpnum += 1;
  //   }

  // },
  mounted() {
    if (typeof this.cancel == 'function') {
      this.cancel()
    }

    if (this.myinterval) {
      // console.log('1没有吗',this.myinterval);
      clearInterval(this.myinterval)
    }
    // console.log(window.screen.height)
    // console.log(window.screen.width )

    // console.log("5555555555555555555555555555555555")
    // this.nowwin=25600/window.screen.width;
    // console.log(this.nowwin)
    //console.log('go123456')

    // window.addEventListener('scroll', this.windowScroll, true);
    this.$emit('changename', this.unitname);
    // console.log(this.equid);
    if (this.equid) {
      // console.log('这里的原因');
      this.getImage(this.equid, 'mounted');
    }

    const that = this;
    that.tmpnum = 0;
    // const erd = elementResizeDetectorMaker();
    let image = document.getElementById("infromtion")
    this.imageheight1 = image.offsetHeight - 6;
    this.imageWidth1 = image.offsetWidth - 6;
    this.imageheight = image.offsetHeight - 6;
    this.imageWidth = image.offsetWidth - 6;
    this.startall() //提前告诉nowstatus已经加载完成
    // erd.listenTo(document.getElementById("infromtion"), element => {
    //     that.$nextTick(() => {
    //       //监听到事件后执行的业务逻辑

    //       // if(Math.abs(that.oldHeight - element.offsetHeight) < 10 || Math.abs(that.oldWidth - element.offsetWidth) < 10) {
    //       //   if(Math.abs(that.oldWidth - element.offsetWidth) < 10) {
    //       //     that.imageheight = element.offsetHeight;
    //       //     that.imageWidth = element.offsetWidth * (element.offsetHeight / that.imHeight);
    //       //   }
    //       // } else {
    //       //   that.imageheight = element.offsetHeight;
    //       //   that.imageWidth = element.offsetWidth;
    //       // }
    //       // that.oldHeight = element.offsetHeight;
    //       // that.oldWidth = element.offsetWidth;
    //       // that.marginleft = this.$store.state.marginleftvalue;
    //       // if(that.$store.state.flaggraph || !that.$store.state.flagopright|| !that.$store.state.flagopleft) {
    //       //   if(that.$store.state.flaggraph) {
    //       //     console.log('显示图谱', that.marginleft);
    //       //     that.imageheight = element.offsetHeight;
    //       //     that.imageWidth = element.offsetWidth * 0.9;
    //       //   } else if(!that.$store.state.flagopright){
    //       //     console.log('关闭右操作页');
    //       //     that.imageheight = element.offsetHeight;
    //       //     that.imageWidth = element.offsetWidth * 0.85;
    //       //   } else {
    //       //     console.log('关闭设备树');
    //       //     that.imageheight = element.offsetHeight;
    //       //     that.imageWidth = element.offsetWidth * 0.85;
    //       //   }
    //       //   if(!that.$store.state.flagopright && !that.$store.state.flagopleft) {
    //       //     console.log('左右都关闭');
    //       //     that.imageheight = element.offsetHeight;
    //       //     that.imageWidth = element.offsetWidth * 0.75;
    //       //   }
    //       //   if(that.$store.state.flaggraph && !that.$store.state.flagopleft) {
    //       //     console.log('左关闭，显示图谱');
    //       //     that.imageheight = element.offsetHeight;
    //       //     that.imageWidth = element.offsetWidth * 0.75;
    //       //   }
    //       //   if(that.$store.state.flaggraph && !that.$store.state.flagopright) {
    //       //     console.log('右关闭，显示图谱');
    //       //     that.imageheight = element.offsetHeight;
    //       //     that.imageWidth = element.offsetWidth * 0.75;
    //       //   }

    //       // }
    //       // else {
    //       //   console.log('全屏显示');
    //       //   that.imageheight = element.offsetHeight;
    //       //   that.imageWidth = element.offsetWidth;
    //       // }
    //       that.tmpnum = 0;
    //       // console.log('应该不会变啊',that.imWidth, that.imHeight);
    //       // console.log('变化后的尺寸', element.offsetHeight, element.offsetWidth);
    //       // if(that.imWidth == 0 && that.imHeight == 0) {
    //       //   that.imageheight = that.imHeight;
    //       //   that.imageWidth = that.imWidth;
    //       // }
    //       // if(that.imWidth > 0 && that.imHeight > 0 && (element.offsetHeight > that.imHeight && element.offsetWidth > that.imWidth)) {
    //       //   that.imageheight = element.offsetHeight;
    //       //   that.imageWidth = element.offsetWidth;
    //       // }
    //       that.imageheight1 = element.offsetHeight - 6;
    //       that.imageWidth1 = element.offsetWidth - 6;
    //       that.imageheight = element.offsetHeight - 6;
    //       that.imageWidth = element.offsetWidth - 6;
    //       // console.log('变化后的尺寸', that.imageheight, that.imageWidth);
    //       let i = 0;
    //       // console.log('hahah', that.timeWidth * Math.min(that.imageheight / that.imHeight, that.imageWidth / that.imWidth));
    //       // console.log(i++,that.num++,that.imageheight, that.imageWidth, that.namefontsize, that.timefontize);
    //       // if(that.oldheight != '' && that.oldwidth != '') {
    //       //   console.log(that.oldheight, that.oldwidth);
    //       //   that.ratio = element.offsetHeight * 1.0 / that.oldheight;
    //       //   that.ratio1 = element.offsetWidth * 1.0 / that.oldwidth;
    //       //   // console.log('我的倍率', that.ratio);
    //       //   that.getgraphdata(that.equid);
    //       //   that.addgraphinformation(that.equid);
    //       // }
    //       // that.getImage(that.equid);
    //     });
    //   });
  },
  beforeDestroy() {
    if (typeof this.cancel == 'function') {
      this.cancel()
    }
    if (this.myinterval) {
      clearInterval(this.myinterval)
    }
  },
  destroyed() {

    if (typeof this.cancel == 'function') {
      this.cancel()
    }
    if (this.myinterval) {
      clearInterval(this.myinterval)
    }
  },
  watch: {
    listBoxes(newVal, oldVal) {
      if(!this.activatedFlag || newVal.length == 0) return ;
      this.$store.state.points = []
      for(let item of newVal) {
        this.$store.state.points.push(...item.points);
      }
    },
    nowtimeStatic(data) {
      if(!this.activatedFlag) return ;
      this.ifnowdata = data;
      console.log('ooooooo');
      // console.log(data)
      this.graps();
    },


  },

  methods: {
    //   windowScroll(){
    //  console.log('11111', document.querySelector(".myclass").parentElement.parentElement.scrollLeft)    // 查看打印的值是否有变化 如果有 则说明滚滚动条在这个标签中
    // },
    getValue(oriValue) { // 测点框的测点值, 也就是接口中的value
      oriValue = String(oriValue);
      if(oriValue.endsWith('m/s2')) // 替换角标
        oriValue = oriValue.replace('m/s2', 'm/s²');
      return oriValue;
    },
    startall() {
      if (this.nowstatus == -1){ ///防止初始化页面时调用，两次启动定时器
        this.nowstatus = 1
      }else{
        this.addgraphinformation(this.equid)
      }
    },

    getstatus(val) {
      let tmptoken = localStorage.getItem('token');
      if (tmptoken) {
        if (val == 0) {
          return 0;
        } else if (val == 5) {
          return 2;
        } else {
          return 1;
        }
      } else {
        return val;
      }
    },
    overlick() {
      if (this.showMenu) {
        this.showMenu = false;
      }
    },
    handleClick(pointId, val) {
      console.log('点击事件', pointId, val, val.target.innerText, val.clientX, val.clientY);
      // if (this.$route.path.indexOf('HeatingFurnaceGraph') != -1) {
      //   return ;
      // }
      // if (this.$route.path == '/UnitOverviewMap') {
      //   this.showMenu = true;
      // }
      // 这里的value存放的是概貌图的容器的横向滚轮和竖向滚轮两个滚轮的偏移量，补足滚轮异常
      let value = this.getScrollValue()
      this.showMenu = true;
      this.pointId = pointId;
      this.$nextTick(() => {
        let menuHeight = document.getElementById('routeMenu').clientHeight;
        console.log(menuHeight);
        let x = val.clientX - 250;
        let y = val.clientY - 60;
        this.boxFlag = true;
        this.$refs.box.style.setProperty('--marginTop', `0px`);
        this.$refs.box.style.setProperty('--direction', 'row');
        // 正常的方向应该是朝右下方向
        // 解释下，判断哪种情况下需要反转菜单，首先y以下的高度不足menuHeight且y以上的高度超过menuHeight。如果都不满足，那么判断y以下的高度+滚轮剩余高度超过menuHeight就可以
        if ((y + menuHeight > this.imageheight + value[3] - value[1]) || ((y > this.imageheight - y) && (value[1] + y > menuHeight))) {
          console.log("是否执行了y + menuHeight > this.imageweight", this.imageheight, (y + menuHeight))
          y -= menuHeight;
          this.$refs.box.style.setProperty('--marginTop', `${menuHeight - 25}px`);
        }
        // // 解释下，判断哪种情况下需要反转菜单，首先y以下的高度不足menuHeight且y以上的高度超过menuHeight。如果都不满足，那么判断y以下的高度+滚轮剩余高度超过menuHeight就可以
        // if( ((y + menuHeight > this.imageheight) && (y >= menuHeight)) || ((y + menuHeight > (this.imageheight+value[3]-value[1])))){
        //   console.log("是否执行了y + menuHeight > this.imageweight",this.imageheight,(y + menuHeight))
        //   y -= menuHeight;
        //   this.$refs.box.style.setProperty('--marginTop', `${menuHeight - 25}px`);
        // }
        if ((x + 275 > this.imageWidth + value[2] - value[0]) || ((x > this.imageWidth - x) && (value[0] + x > 275))) {
          // x -= (x + 275 - this.imageWidth);
          console.log("是否执行了x + menuHeight > this.imageweight", this.imageWidth, (x + menuHeight))
          x -= 275;
          this.boxFlag = false;
          this.$refs.box.style.setProperty('--direction', 'row-reverse');
        }
        // if (((x + 275 > this.imageWidth) && (x >= 275)) || ((x + 275 > (this.imageWidth+value[2]-value[0])))) {
        //   // x -= (x + 275 - this.imageWidth);
        //   console.log("是否执行了x + menuHeight > this.imageweight",this.imageWidth,(x + menuHeight))
        //   x -= 275;
        //   this.boxFlag = false;
        //   this.$refs.box.style.setProperty('--direction', 'row-reverse');
        // }
        this.x = x + value[0]
        this.y = y + value[1]
      })
    },
    handleSelect(val) {
      console.log('选择', val);
      this.showMenu = false;
      if (val) {
        let tempPointId = ''
        this.equipmentDetail[this.equid].forEach(item => {
          if(item.pointName == this.pointId) tempPointId = item.pointId
        })
        this.$store.state.pointId = tempPointId
        this.$store.state.globalPointId = tempPointId
        this.$router.push({path: val, query: this.$route.query});
      }
    },
    //获得概貌图
    stopinterval() {
      if (this.interval2) {
        clearInterval(this.interval2);
      }
    },
    mytop() {
      // console.log('打印高度', this.revInfoTop * Math.max(1,Math.min(this.imageheight1 / this.imHeight, this.imageWidth1 / this.imWidth)), this.revInfoHight * Math.min(this.imageheight1 / this.imHeight, this.imageWidth1 / this.imWidth));
      let tmpmax = -1;
      for (let i = 0; i < this.listBoxes.length; i++) {
        if (i == 0) tmpmax = parseInt(this.listBoxes[i].yPos, 10);
        else tmpmax = Math.min(tmpmax, parseInt(this.listBoxes[i].yPos, 10));
      }
      if (Math.floor(tmpmax / this.imHeight * (Math.max(this.imHeight, Math.min(this.imageheight, this.imHeight * (this.imageheight < this.imageWidth ? this.imageheight / this.imHeight : this.imageWidth / this.imWidth))))) > this.imageheight / 2) {
        // console.log('不变了', Math.floor(tmpmax / this.imHeight * (Math.max(this.imHeight, Math.min(this.imageheight, this.imHeight * (this.imageheight < this.imageWidth ? this.imageheight / this.imHeight : this.imageWidth / this.imWidth) )))), this.imageheight);
        return 0;
      } else
        return Math.max(0, Math.floor(tmpmax / this.imHeight * (Math.max(this.imHeight, Math.min(this.imageheight, this.imHeight * (this.imageheight < this.imageWidth ? this.imageheight / this.imHeight : this.imageWidth / this.imWidth))))) - this.revInfoTop * Math.max(1, Math.min(this.imageheight1 / this.imHeight, this.imageWidth1 / this.imWidth)) - this.revInfoHight * Math.min(this.imageheight1 / this.imHeight, this.imageWidth1 / this.imWidth) - 20)
      // console.log('最小的高度', tmpmax, parseInt(this.listBoxes[0].yPos, 10));
      // let tmptop = document.getElementsByClassName('revInfo');
      // console.log('打印变量', tmptop[0].style.cssText, typeof(tmptop[0].style.cssText));
      // console.log('我的style', tmptop[0].style.cssText.height, typeof(tmptop[0].style.cssText.height));
      // if(tmptop[0].style.cssText.height != '0px' && tmptop[0].style.cssText.top != '0px') {
      //   let tmpmax = -1;

      //   for(let item in this.listBoxes) {
      //     tmpmax = Math.max(tmpmax, item.yPos);
      //   }
      // }
      // return '0px'
    },
    myleft(val) {
      let canvas = document.createElement('canvas');
      let context = canvas.getContext('2d');
      context.font = '24px Avenir Helvetica Arial sans-serif';
      let dimension = context.measureText(val);
      // console.log('标题宽度', dimension.width);
      return (this.imageWidth1 - dimension.width) / 2;
    },
    myLength(val) {
      let canvas = document.createElement('canvas');
      let context = canvas.getContext('2d');
      context.font = '24px Avenir Helvetica Arial sans-serif';
      let dimension = context.measureText(val);
      return dimension.width;
    },
    timeLength(val) {
      let canvas = document.createElement('canvas');
      let context = canvas.getContext('2d');
      context.font = this.fontSize.toString() + 'px Avenir Helvetica Arial sans-serif';
      let dimension = context.measureText(val);
      return dimension.width * 1.5;
    },
    startmyinterval() {

      if (this.interval2) {
        clearInterval(this.interval2);
      }
      this.interval2 = setInterval(() => {
        this.addgraphinformation(this.equid);
      }, this.$store.state.realTimeTrendUpdateInterval)
    },
    getImage(id, from) {
      // this.nowwin=1;
      var CancelToken = this.$axios.CancelToken;

      if (typeof this.cancel == 'function') {
        this.cancel()
      }
      console.log('概貌图开始', from);
      if (this.myinterval) {
        // console.log('123');
        clearInterval(this.myinterval)
      }
      this.$emit('dataloading');
      var nowid = encodeURIComponent(id)
      this.apiflag = true;

      let that = this;
      this.$axios.get("/graph/" + nowid + "/info", {
        cancelToken: new CancelToken((c) => {
          // executor 函数接收一个 cancel 函数作为参数
          that.cancel = c;
        })
      })
        .then(res => {
          if (res.data.code == 200) {
            // this.$emit('datasuccess');

            let nodeData = res.data.data;
            // console.log(nodeData);
            this.codeBase = 'data:image/png;base64,' + nodeData.graphImageBase64Code; //转码
            // var tmp = document.getElementById("infromtion");
            // console.log('窗口大小', tmp.offsetHeight, + ' ' + tmp.offsetWidth, this.oldheight);
            // if(this.oldheight == '') {
            //   console.log('true');
            //   this.oldheight = nodeData.graphImageHeight;
            //   this.oldwidth = nodeData.graphImageWidth;
            // }
            // this.fontsize = nodeData.fontSize;
            // if(this.fontsize == 0) {
            //   this.fontsize = 9;
            // }
            this.fontSize = 12;
            if (this.fontSize == '' || this.fontSize < nodeData.fontSize) this.fontSize = nodeData.fontSize;
            // console.log('图片尺寸', nodeData.graphImageHeight + ' ' + nodeData.graphImageWidth, this.fontsize);
            // this.imageheight = nodeData.graphImageHeight;
            // this.imageWidth = nodeData.graphImageWidth;
            // if(this.oldwidth != '' && this.oldwidth < tmp.offsetWidth) {
            //   this.ratio = tmp.offsetWidth * 1.0 / this.oldwidth;
            //   this.imageheight = (nodeData.graphImageHeight * this.ratio).toFixed(0) + 'px';
            //   this.imageWidth = (nodeData.graphImageWidth * this.ratio).toFixed(0) + 'px';
            // }
            // console.log('新图片尺寸', this.imageheight + ' ' + this.imageWidth);
            // this.imageheight =  '1080px';
            // this.imageWidth = "1820px";
            this.imWidth = nodeData.graphImageWidth;
            this.imHeight = nodeData.graphImageHeight;
            // this.imageheight = this.imHeight;
            // this.imageWidth = this.imWidth;
            this.$emit('imageWidth', this.imWidth);
            this.$emit('imageheight', this.imHeight);
            this.graphImageBackground = nodeData.graphImageBackground;

            this.$emit("graphImageBackground", this.graphImageBackground);//发送背景颜色
            // let _that = that;
            this.$nextTick(() => {

              // this.$emit('changthispostion',this.imWidth, this.imHeight)
              // this.$emit('imWidth',this.imWidth)

              setTimeout(function () {

                that.$emit('gomid');
              }, 5000)

              if (that.codeBase != '') {
                that.getgraphdata(that.equid, from);
              }
              //    this.addgraphinformation(this.equid);
            })
          } else {
            console.log('请求失败');
            // that.$emit('datafail');
          }

        });
      if (this.myinterval) {
        // console.log('123');
        clearInterval(this.myinterval)
      }
      this.myinterval = setInterval(() => {
        if (this.codeBase != '') {
          clearInterval(this.myinterval)
          //this.$nextTick(() => {
          setTimeout(function () {

            that.$emit('gomid');
          }, 5000)
          that.getgraphdata(that.equid);
          //})
        }
          // console.log('我的编码');
        // console.log('开始定时器', this.codeBase);
        else {
          that.$axios.get("/graph/" + nowid + "/info")
            .then(res => {
              if (res.data.code == 200) {
                // this.$emit('datasuccess');

                let nodeData = res.data.data;
                console.log(nodeData);
                that.codeBase = 'data:image/png;base64,' + nodeData.graphImageBase64Code; //转码
                // var tmp = document.getElementById("infromtion");
                // console.log('窗口大小', tmp.offsetHeight, + ' ' + tmp.offsetWidth, this.oldheight);
                // if(this.oldheight == '') {
                //   console.log('true');
                //   this.oldheight = nodeData.graphImageHeight;
                //   this.oldwidth = nodeData.graphImageWidth;
                // }
                // this.fontsize = nodeData.fontSize;
                // if(this.fontsize == 0) {
                //   this.fontsize = 9;
                // }
                that.fontSize = 12;
                if (that.fontSize == '' || that.fontSize < nodeData.fontSize) that.fontSize = nodeData.fontSize;
                // console.log('图片尺寸', nodeData.graphImageHeight + ' ' + nodeData.graphImageWidth, this.fontsize);
                // this.imageheight = nodeData.graphImageHeight;
                // this.imageWidth = nodeData.graphImageWidth;
                // if(this.oldwidth != '' && this.oldwidth < tmp.offsetWidth) {
                //   this.ratio = tmp.offsetWidth * 1.0 / this.oldwidth;
                //   this.imageheight = (nodeData.graphImageHeight * this.ratio).toFixed(0) + 'px';
                //   this.imageWidth = (nodeData.graphImageWidth * this.ratio).toFixed(0) + 'px';
                // }
                // console.log('新图片尺寸', this.imageheight + ' ' + this.imageWidth);
                // this.imageheight =  '1080px';
                // this.imageWidth = "1820px";
                that.imWidth = nodeData.graphImageWidth;
                that.imHeight = nodeData.graphImageHeight;
                // this.imageheight = this.imHeight;
                // this.imageWidth = this.imWidth;
                that.$emit('imageWidth', that.imWidth);
                that.$emit('imageheight', that.imHeight);
                that.graphImageBackground = nodeData.graphImageBackground;

                that.$emit("graphImageBackground", that.graphImageBackground);//发送背景颜色
                let _that = that;
                that.$nextTick(() => {

                  // this.$emit('changthispostion',this.imWidth, this.imHeight)
                  // this.$emit('imWidth',this.imWidth)

                  setTimeout(function () {

                    _that.$emit('gomid');
                  }, 5000)

                  if (_that.codeBase != '') {
                    clearInterval(_that.myinterval)
                    _that.getgraphdata(_that.equid);
                  }
                  //    this.addgraphinformation(this.equid);
                })
              } else {
                console.log('请求失败');
                // that.$emit('datafail');
              }
            });
        }
      }, this.$store.state.realTimeTrendUpdateInterval);


    },
    //获得概貌图数据
    getgraphdata(id, from) {
      console.log("qdy=>判断实时状态下概貌图请求数据是否为定时启动",)
      window.clearTimeout(this.graphDataTime);
      // $("#gmt").html("");      //清数据
      // $("#information").html("");
      this.listBoxes = [];
      this.listSpan = {};
      var CancelToken = this.$axios.CancelToken;
      if (typeof this.cancel == 'function') {
        this.cancel()
      }
      var nowid = encodeURIComponent(id)
      this.$emit('dataloading');
      let that = this;
      if (this.myinterval) {
        clearInterval(this.myinterval)
      }
      let tmp_res = true;
      // this.myinterval = setInterval(() => {
      if (tmp_res) {
        tmp_res = false;
        that.$axios.get("/graph/" + nowid + "/data"
          , {
            cancelToken: new CancelToken((c) => {
              // executor 函数接收一个 cancel 函数作为参数
              that.cancel = c;
            })
          })
          .then(res => {
            tmp_res = true;
            if (res.data.code == 200) {
              var raised = 0;
              that.$emit('datasuccess');
              let graphData = res.data.data;
              // console.log(graphData)
              if (graphData.listBoxes.length == 0) {
                that.$emit('datanull');
              }
              graphData.equipmentName = graphData.equipmentName || {
                yPos: "",
                width: "",
                equipmentName: "",
                xPos: "",
                height: ""
              };
              // console.log('属性', typeof(Number(graphData.equipmentName.yPos)));
              let tmp_ratio = Math.min(this.imageheight / this.imHeight, this.imageWidth / this.imWidth);
              that.equipmentsName = graphData.equipmentName.equipmentName || '';
              that.equipmentNameTop = 20 || '';
              that.equipmentNameleft = this.imageWidth / 3 + "px" || '';
              that.equipmentNameHight = graphData.equipmentName.height || '';
              that.equipmentNameWidth = (graphData.equipmentName.equipmentName.length * 20) || '';
              that.namefontsize = 9 || '';
              // this.namefontsize = Math.ceil(this.fontsize * this.ratio).toString() + 'px';
              // this.equipmentNameTop=graphData.equipmentName.yPos+"px" || '';
              // this.equipmentNameleft=graphData.equipmentName.xPos+"px" || '';
              // this.equipmentNameHight=graphData.equipmentName.height+'px'||'';
              // this.equipmentNameWidth=graphData.equipmentName.width+'px'||'';
              graphData.time = graphData.time || {
                yPos: "",
                width: "",
                time: "",
                xPos: "",
                height: ""
              }
              that.time = graphData.time.time || '';
              if (that.$route.path.includes('/Offline/')) {
                that.time = '巡检时间: ' + timestampToTimeFormat(Number(that.time.slice(-13)));
              }
              that.timeTop = 20 || '';
              that.timeLeft = (this.imageWidth / 3 + graphData.equipmentName.equipmentName.length * 25) + "px" || '';
              that.timeHight = graphData.time.height || '';
              // this.timefontize = Math.ceil(this.fontsize * Math.max(this.ratio, this.ratio1)).toString() + 'px';
              that.timefontize = Math.ceil(9 * tmp_ratio) + "px" || '';
              that.timeWidth = graphData.time.time.length / 1.7 || '';
              // console.log('12333', this.timeWidth);
              // this.timeTop=graphData.time.yPos+'px' || '';
              // this.timeLeft=graphData.time.xPos+'px'|| '';
              // this.timeHight=graphData.time.height+'px'||'';
              // this.timeWidth=graphData.time.width+'px'||'';
              // if(Object.prototype.toString.call(graphData.revInfo )==='[object Object]'){
              //   graphData.revInfo=graphData.revInfo;
              // }
              //   else{
              //   graphData.revInfo='';
              // }
              // graphData.revInfo=  Object.prototype.toString.call(graphData.revInfo )==='[object Object]'|| [];
              //  console.log(graphData);


              // graphData.revInfo = graphData.revInfo || {
              //   转速: {
              //     yPos: "",
              //     width: "",
              //     xPos: "",
              //     revName: "",
              //     revValue: "",
              //     height: ""
              //   }
              // }
              // graphData.revInfo.转速 = graphData.revInfo.转速 || {
              //   yPos: "",
              //   width: "",
              //   xPos: "",
              //   revName: "",
              //   revValue: "",
              //   height: ""
              // }
              // that.revInfo.revName = graphData.revInfo.转速.revName ||'';
              // that.revInfo.revValue = graphData.revInfo.转速.revValue ||'';
              that.revInfoList = [];
              for (let key in graphData.revInfo) {
                console.log("key", key)
                let revName = graphData.revInfo[key].revName || '';
                let revValue = graphData.revInfo[key].revValue || '';
                let yPos = Number(graphData.revInfo[key].yPos);
                console.log("ddddddddd")
                that.revInfoList.push({
                  revName: this.translateText("textMap.",revName),
                  revValue: revValue,
                  yPos: yPos
                })
              }

              that.revInfoList.sort((a, b) => {
                return a.yPos - b.yPos
              })

              // console.log(that.revInfoList)


              that.revInfoTop = 50 || '';
              that.revInfoLeft = (this.imageWidth / 3 + graphData.equipmentName.equipmentName.length * 25) + "px" || '';
              // that.revInfoHight=graphData.revInfo.转速.height || '';
              // this.revfontsize = Math.ceil(this.fontsize * Math.max(this.ratio, this.ratio1)).toString() + 'px';
              that.revfontsize = Math.ceil(9 * tmp_ratio) + "px" || '';
              that.revInfoWidth = this.timeWidth || '';
              // this.revInfoTop=graphData.revInfo.转速.yPos+'px'||'px';
              // this.revInfoLeft=graphData.revInfo.转速.xPos+'px'||'px';
              // this.revInfoHight=graphData.revInfo.转速.height+'px'||'px';
              // this.revInfoWidth=graphData.revInfo.转速.width+'px'||'px'
              that.listBoxes = graphData.listBoxes;
              // for (var i in graphData.listBoxes) {
              //   var v = graphData.listBoxes[i];
              //   $('#gmt').append('<div class="point_box point_box' + i + '" style="width:' + parseInt(v.width, 10) * this.ratio1 + 'px' + ' ;height:' + parseInt(v.height, 10) * this.ratio + 'px' + '; top:' + parseInt(v.yPos, 10) * this.ratio + 'px'  + ';left:' + parseInt(v.xPos, 10) * this.ratio1  + 'px'  + ';"></div>');
              //   // $('#gmt').append('<div class="point_box point_box' + i + '" style="width:' + Math.floor(parseInt(v.width, 10) * this.ratio).toString() + 'px' + ' ;height:' + Math.floor(parseInt(v.height, 10) * this.ratio).toString() + 'px' + '; top:' + Math.floor(parseInt(v.yPos, 10) * 1).toString() + 'px'  + ';left:' + Math.floor(parseInt(v.xPos, 10) * this.ratio).toString()  + 'px'  + ';"></div>');
              //   // console.log('倍率', this.ratio, (parseInt(v.width, 10) * this.ratio), typeof(parseInt(v.width, 10) * this.ratio))
              //   // console.log('比较', parseInt(v.width, 10), Math.floor(parseInt(v.width, 10) * this.ratio).toString())
              //   $('.point_box' + i).html(' ')
              //   var maxWidth = 0
              //   for(var j in v.points){
              //     var val = v.points[j];
              //     var len = 0;
              //     var str = String (val.pointId)
              //     for (let p=0;p<str.length;p++){
              //       if(str.charCodeAt(p) > 127){
              //         len += 12
              //       }
              //       else {
              //         len += 8
              //       }
              //     }
              //     maxWidth = Math.max(maxWidth,len)
              //   }
              //   var tmp_fontsize = Math.ceil(this.fontsize * this.ratio);
              //   // maxWidth = tmp_fontsize;
              //   // console.log('字体大小',this.fontsize, this.ratio, tmp_fontsize);
              //   for (var j in v.points) {
              //     var val = v.points[j];
              //     $('.point_box' + i).append(`<li class="alarmStatus_${val.status}"  title="${val.pointId}">` + '<span  style="width: '+maxWidth+'px; font-size:'+tmp_fontsize+'px; display:-moz-inline-box; display:inline-block;overflow: hidden;  vertical-align: top;">'+ val.pointId +'</span>  '+ '<span style="margin-left: 8px; font-size:'+tmp_fontsize+'px;">'+ val.value +'</span>  '+ '</li>' )

              //   }
              // }
              /*    if(this.ifnowdata == 'true'){
                    that.myinterval = setInterval(function () {
                      var CancelToken = that.$axios.CancelToken
                      console.log('12345')
                      that.$axios.get("/graph/" + id + "/data")
                        .then(res => {
                          if (res.data.code == 200) {
                            var raised = 0;
                            that.$emit('datasuccess');
                            let graphData = res.data.data;
                            console.log(graphData);
                            console.log('获取图片的数据')
                            that.equipmentsName = graphData.equipmentName.equipmentName;
                            that.time = graphData.time.time;
                            that.revInfo.revName = graphData.revInfo.转速.revName;
                            that.revInfo.revValue = graphData.revInfo.转速.revValue;
                            $("#gmt").html("");      //清数据
                            $("#information").html("");
                            for (var i in graphData.listBoxes) {
                              var v = graphData.listBoxes[i];
                              $('#gmt').append('<div class="point_box point_box' + i + '" style="width:' + parseInt(v.width, 10) + 'px' + ' ;height:' + parseInt(v.height, 10) + 'px' + '; top:' + parseInt(v.yPos, 10) + 'px' + ';left:' + parseInt(v.xPos, 10) + 'px' + ';"></div>');

                              $('.point_box' + i).html(' ')
                              for (var j in v.points) {
                                var val = v.points[j];
                                $('.point_box' + i).append(`<li class="alarmStatus_${val.status}"  title="${val.pointId}">` + val.pointId + ': ' + val.value + '</li>' )
                                $('.point_box' + i).trigger("create");
                              }
                            }
                          } else {
                            console.log('请求失败');
                            that.$emit('datafail');
                          }
                        })

                    }, 5000)
                  }else{
                    clearInterval( this.myinterval );
                  }*/
              if (that.listBoxes.length > 0) {
                clearInterval(that.myinterval);
                // console.log('清除定时器开始更新测点数据');
                // that.addgraphinformation(that.equid);
              }
              // that.$nextTick(() => {
              //   //  this.getgraphdata(this.equid);
              //   that.addgraphinformation(this.equid);
              // })
            } else {
              console.log('请求失败');
              that.$emit('datafail');
            }
            if(this.activatedFlag) this.addgraphinformation(this.equid, from)
          }).catch(e => {
        });
      }
      // }, 3000);


    },
    clearinterval() {
      if (this.myinterval) {
        clearInterval(this.myinterval);
      }
      if (this.interval2) {
        clearInterval(this.interval2);
      }
    },

    addgraphinformation(id, from) {
      //   this.getgraphdata(this.equid);
      let that = this;
      if (this.myinterval) {
        clearInterval(this.myinterval)
      }
      let tmp_res = true;
      // console.log(this.nnnn++,'裂开了', this.myinterval, id);
      this.myinterval = setInterval(() => {

        var CancelToken = that.$axios.CancelToken;
        var nowid = encodeURIComponent(id)
        if (tmp_res) {
          tmp_res = false;
          that.$axios.get("/graph/" + nowid + "/data")
            //取消定时器间隔结束请求未完成取消请求
            // ,{
            // cancelToken: new CancelToken((c) => {
            //   // executor 函数接收一个 cancel 函数作为参数
            //   this.cancel = c;
            // })
            // })
            .then(res => {
              tmp_res = true;
              // console.log('我的请求完成');
              if (res.data.code == 200) {
                var raised = 0;
                // this.$emit('datasuccess');
                let graphData = res.data.data;
                // console.log(graphData);
                // console.log('222222222222222222222222222222')
// console.log(that.nowwin)
                graphData.equipmentName = graphData.equipmentName || {
                  yPos: "",
                  width: "",
                  equipmentName: "",
                  xPos: "",
                  height: ""
                };
                let tmp_ratio = Math.min(that.imageheight / that.imHeight, that.imageWidth / that.imWidth);
                that.equipmentsName = graphData.equipmentName.equipmentName || "";
                that.equipmentNameTop = 20 || '';
                that.equipmentNameleft = that.imageWidth / 3 + "px" || '';
                that.equipmentNameHight = graphData.equipmentName.height || '';
                that.equipmentNameWidth = (graphData.equipmentName.equipmentName.length * 20) || '';
                // this.namefontsize = Math.ceil(this.fontsize * Math.max(this.ratio, this.ratio1)).toString() + 'px';
                that.namefontsize = Math.ceil(9 * tmp_ratio) + "px" || '';
                // that.equipmentNameTop=graphData.equipmentName.yPos+"px"||'px';
                // that.equipmentNameleft=graphData.equipmentName.xPos+"px"||'px';
                // that.equipmentNameHight=graphData.equipmentName.height+'px'||'';
                // that.equipmentNameWidth=graphData.equipmentName.width+'px'||'';

                graphData.time = graphData.time || {
                  yPos: "",
                  width: "",
                  time: "",
                  xPos: "",
                  height: ""
                }
                that.time = graphData.time.time || '';
                if (that.$route.path.includes('/Offline/')) {
                  that.time = '巡检时间: ' + timestampToTimeFormat(Number(that.time.slice(-13)));
                }
                that.timeTop = 20 || '';
                that.timeLeft = (that.imageWidth / 3 + graphData.equipmentName.equipmentName.length * 25) + "px" || '';
                that.timeHight = graphData.time.height || '';
                // this.timefontize = Math.ceil(this.fontsize * Math.max(this.ratio, this.ratio1)).toString() + 'px';
                that.timefontize = Math.ceil(9 * tmp_ratio) + "px" || '';
                that.timeWidth = graphData.time.time.length / 1.7 || '';
                // console.log('456', that.timeWidth);
                // that.timeTop=graphData.time.yPos+'px'||'px';
                // that.timeLeft=graphData.time.xPos+'px'||'px';
                // that.timeHight=graphData.time.height+'px'||'';
                // that.timeWidth=graphData.time.width+'px'||'';
                // if(Object.prototype.toString.call(graphData.revInfo )==='[object Object]'){
                //   graphData.revInfo=graphData.revInfo;
                // }
                // else{
                //   graphData.revInfo=  [];
                // }

                //console.log(graphData.revInfo.转速.revName||'转速')
                // graphData.revInfo = graphData.revInfo || {
                //   转速: {
                //     yPos: "",
                //     width: "",
                //     xPos: "",
                //     revName: "",
                //     revValue: "",
                //     height: ""
                //   }
                // }
                // graphData.revInfo.转速 = graphData.revInfo.转速 || {
                //   yPos: "",
                //   width: "",
                //   xPos: "",
                //   revName: "",
                //   revValue: "",
                //   height: ""
                // }
                // that.revInfo.revName = graphData.revInfo.转速.revName||'';
                // that.revInfo.revValue = graphData.revInfo.转速.revValue||'';

                that.revInfoList = [];
                for (let key in graphData.revInfo) {
                  console.log("key", key)
                  let revName = graphData.revInfo[key].revName || '';
                  let revValue = graphData.revInfo[key].revValue || '';
                  let yPos = Number(graphData.revInfo[key].yPos);
                  that.revInfoList.push({
                    revName: this.translateText("textMap.",revName),
                    revValue: revValue,
                    yPos: yPos
                  })
                }

                that.revInfoList.sort((a, b) => {
                  return a.yPos - b.yPos
                })

                // console.log(that.revInfoList)


                that.revInfoTop = 50 || '';
                that.revInfoLeft = (that.imageWidth / 3 + graphData.equipmentName.equipmentName.length * 25) + "px" || '';
                // that.revInfoHight=graphData.revInfo.转速.height || '';
                // this.revfontsize = Math.ceil(this.fontsize * Math.max(this.ratio, this.ratio1)).toString() + 'px';
                that.revfontsize = Math.ceil(9 * tmp_ratio) + "px" || '';
                that.revInfoWidth = that.timeWidth || '';
                // that.revInfoTop=graphData.revInfo.转速.yPos+'px'||'px';
                // that.revInfoLeft=graphData.revInfo.转速.xPos+'px'||'px';
                // that.revInfoHight=graphData.revInfo.转速.height+'px'||'px';
                // that.revInfoWidth=graphData.revInfo.转速.width+'px'||'px';
                // $("#gmt").html("");      //清数据
                // $("#information").html("");
                that.listBoxes = graphData.listBoxes;
                // console.log('刷新数据：', that.listBoxes);
                // for (var i in graphData.listBoxes) {
                //   var v = graphData.listBoxes[i];
                //   // console.log('倍率2', that.ratio, (parseInt(v.width, 10) * that.ratio), typeof(parseInt(v.width, 10) * that.ratio))
                //   $('#gmt').append('<div class="point_box point_box' + i + '" style="width:' + (parseInt(v.width, 10) * that.ratio1)+ 'px' + ' ;height:' + (parseInt(v.height, 10) * that.ratio) + 'px' + '; top:' + (parseInt(v.yPos, 10)* that.ratio) + 'px'  + ';left:' + (parseInt(v.xPos, 10) * that.ratio1) + 'px'  + ';"></div>');

                //   $('.point_box' + i).html(' ')
                //   var maxWidth = 0
                //   for(var j in v.points){
                //     var val = v.points[j];
                //     var len = 0;
                //     var str = String (val.pointId)
                //     for (let p=0;p<str.length;p++){
                //       if(str.charCodeAt(p) > 127){
                //         len += 12
                //       }
                //       else {
                //         len += 8
                //       }
                //     }
                //     maxWidth = Math.max(maxWidth,len)
                //   }
                //   var tmp_fontsize = Math.ceil(that.fontsize * that.ratio);
                //   // maxWidth = tmp_fontsize * 6;
                //   // console.log('字体大小2',that.fontsize, that.ratio, tmp_fontsize);
                //   for (var j in v.points) {
                //     var val = v.points[j];

                //     $('.point_box' + i).append(`<li class="alarmStatus_${val.status}"  title="${val.pointId}">` + '<span  style="width: '+maxWidth+'px; font-size:'+tmp_fontsize+'px; display:-moz-inline-box; display:inline-block;overflow: hidden;  vertical-align: top;">'+ val.pointId +'</span>  '+ '<span style="margin-left: 8px;font-size:'+tmp_fontsize+'px;">'+ val.value +'</span>  '+ '</li>' )
                //     $('.point_box' + i).trigger("create");
                //   }
                // }
              } else {
                console.log('请求失败');
                this.$emit('datafail');
              }
            })
            .catch(e => {
            });
        } else {
          // console.log('上次请求未完成');
        }

      }, this.$store.state.realTimeTrendUpdateInterval)
    },
    calsize(val) {
      let tmpratio;
      if (this.imageheight < this.imageWidth) {
        tmpratio = this.imageheight / this.imHeight;
      } else {
        tmpratio = this.imageWidth / this.imWidth;
      }
      if (val == 1) {
        return this.imHeight * tmpratio + 'px';
      } else {
        return this.imWidth * tmpratio + 'px';
      }
    },
    dataloading() {

      this.$emit('dataloading');
    },
    stopnowinterval() {
      if (this.myinterval) {
        clearInterval(this.myinterval);
      }
    },

    cancelRequest() {
      if (typeof this.source === 'function') {
        this.source('终止请求')
      }
    },

    clearchart() {
      var CancelToken = this.$axios.CancelToken;

      if (typeof this.cancel == 'function') {
        this.cancel()
      }
//   this.$refs.trendg.clearall();

    },

    drawHistoryGraph(time, data, rev) {
      // console.warn(data);
      this.ifnowdata = false;
      this.nowstatus = 0
      this.time = time;
      this.revInfo.revValue = rev;
      // console.log('eeee', data)
      let dataLen = data.length;
      for (let i = 0; i < dataLen; i++) {

        for (let j in this.listBoxes)
          for (let k in this.listBoxes[j].points) {
            if (this.listBoxes[j].points[k].pointId === data[i].pointId.replace("#", "\\#")) {
              // 非响应式赋值
              this.$set(this.listBoxes[j].points[k], 'value', data[i].value.toFixed(2) + data[i].unit)
              // console.log('历史请求数据刷新：',this.listBoxes[j].points[k].pointId, this.listBoxes[j].points[k].value);
            }
          }
      }
      this.listSpan = {}
      this.graps()
    },
    graps() {
      if (this.ifnowdata) {    //true画实时的信息
        // console.log('实时');
        this.addgraphinformation(this.equid)
      } else {
        // console.log('历史');
        clearInterval(this.myinterval);
      }
    },
    // timestampToTime(timestamp) {
    //   var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    //   var Y = date.getFullYear() + '-';
    //   var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    //   var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
    //   var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    //   var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    //   var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()) + '.';
    //   var ms = (timestamp % 1000).toString()
    //   while (ms.length < 3) {
    //     ms = '0' + ms
    //   }
    //   //var nowtime = new Date(Y+M+D+h+m+s);
    //   return Y + M + D + h + m + s + ms;
    // },
    calMaxWidth(windowSize, pointList, spanIndex) {
      let canvas = document.createElement('canvas');
      let context = canvas.getContext('2d');
      context.font = this.fontSize.toString() + 'px Avenir Helvetica Arial sans-serif';
      let dimension = context.measureText(pointList);
      // console.log('我的宽度', dimension.width, pointList, spanIndex, this.fontSize, typeof(this.fontSize));
      if (spanIndex == 0 && !this.listSpan[spanIndex]) {
        this.listSpan = {};
      }
      if (!this.listSpan[spanIndex]) {
        // console.log('第一个数据');
        this.listSpan[spanIndex] = dimension.width * 1.15;
      } else {
        this.listSpan[spanIndex] = Math.max(this.listSpan[spanIndex], dimension.width * 1.15);
      }
      return this.listSpan[spanIndex];
      // var valuemaxWidth = 0
      // var smallchar = [33, 34, 39, 40, 41, 42, 43, 44, 45, 46, 47, 72, 73, 91, 92, 93, 94, 95, 96, 123, 124, 125]
      // for(var j in pointList){
      //   var val = pointList[j];
      //   // 计算span左侧标题的长度
      //   var len = 0;
      //   var str = String (val.pointId)
      //   for (let p=0;p<str.length;p++){
      //     if(smallchar.indexOf(str.charCodeAt(p)) === -1){ //显示距离较大
      //       len += 12
      //     }
      //     else {
      //       len += 6
      //     }
      //   }
      //   maxWidth = Math.max(maxWidth,len)
      //   // 计算span右侧数值的长度
      //   len = 0;
      //   str = String (val.value)
      //   for (let p=0;p<str.length;p++){
      //     if(smallchar.indexOf(str.charCodeAt(p)) === -1){
      //       len += 12
      //     }
      //     else {
      //       len += 6
      //     }
      //   }
      //   valuemaxWidth = Math.max(valuemaxWidth, len)
      // }
      // // 右侧span占 8 + valuemaxWidth
      // windowSize -= (8 + valuemaxWidth + 8);
      // this.listSpan[spanIndex] = maxWidth > windowSize ? maxWidth: windowSize
      // return this.listSpan[spanIndex];
    }
  }
}
</script>

<style lang="scss">


.infromtion {
  // overflow: auto;
  margin: auto;
  position: relative;
  // justify-content: space-between;
  // display: flex;
  // flex-direction: row;
  .alarmStatus_2 {
    color: red; //危险
  }

  .alarmStatus_1 {
    color: yellow; //报警
  }
  .gmt {
    color: #001429;
  }

  .myclass, .routeMenu {
    position: absolute;
    // overflow: auto;
    // margin-left: auto;
    // margin:auto;
    // left:0px;
    // top: -100px;
    // right:0px;
    // bottom:0px;


  }

  .routeMenu {
    --marginTop: 0px;
    --direction: row;
    font-family: "微软雅黑", serif;
    height: auto;
    width: auto;
    display: flex;
    flex-direction: var(--direction);
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
    position: absolute;
    background-color: rgba(0, 0, 0, 0);
    color: black;

    .sele {
      display: flex;
      // margin-left: 2px;
      width: 70px;
      height: 25px;
      margin-top: var(--marginTop);
      align-items: center;
      justify-content: center;
      background-color: #fff;
    }

    .menu {
      background-color: #fff;
      font-family: "微软雅黑", serif;
      width: calc(100% - 80px);
      margin: 0%;
      line-height: 25px;
      padding-left: 10px;
      cursor: pointer;
      border-bottom: 0;
    }

    li {
      list-style: none;
      padding: 2px 0px;

      img {
        width: 30px;
        height: 15px;
        background-color: #EFEFEF;
      }
    }

    .menu li:hover {
      background-color: #FFE7A2;
    }
  }

  #div_img {
    z-index: 1;

    // left: 50%;
    // transform: translate(-50%);
  }

  #div_info {
    z-index: 3;
    margin-left: 50%;
    // transform: translate(-50%);
    // margin: auto;
  }

  #div_menu {
    z-index: 4;
  }

  .myname {
    text-align: center;
  }

  .info {
    position: absolute;
    width: 100%;
    z-index: 2;
    display: flex;
    justify-content: center;
  }

  .info table td {
    color: #fff;
  }

  .info td:nth-child(1) {
    font-size: 24px;
    padding-top: 20px;
    padding-right: 30px;
  }

  //.info td:nth-child(even) {
  //  text-align: right;
  //}

  .equipmentName {
    //  background-color: yellow;
    position: absolute;
    z-index: 1;
    color: #fff;
    // top: 90px;
    //   left: 400px;
    // width: 200px;
    margin: 0 auto;
    // text-align: center;
    // text-align: left;
    font-size: 25px;
  }

  .equipmentTime {
    font-size: 15px;
    // width: 200px;
    text-align: right;
    //  background-color: #67c23a;
    position: absolute;
    z-index: 1;
    color: #fff;
    //  top: 90px;
    //    left: 610px;

    //   min-width: 290px;
    margin: 0 auto;
    // float: left;
    //  left: 400px;
    //   text-align: center;
  }

  .revInfo {
    font-size: 18px;
    //width: 200px;
    text-align: right;
    position: absolute;
    z-index: 1;
    color: #fff;
    // background-color: #3a8ee6;
    //  top: 110px;
    //   left: 610px;

    //  min-width: 290px;
    margin: 0 auto;
    // float: left;
    // text-align: center;
  }

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    margin-left: 50%;
    background-color: #061d74;
  }

  ::-webkit-scrollbar-thumb {
    margin-left: 50%;
    background-color: #646563;
  }


  .point_box {
    display: block;
    white-space: nowrap;
    font-size: 12px;
    color: #ececec;
    position: absolute;
    border: 1px solid #fff;
    overflow: auto;
    list-style: none
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ComUtils/UnitOverviewGrap.vue